import { render, staticRenderFns } from "./ChangeOfDeputySecretary.vue?vue&type=template&id=59b07f7c&scoped=true&"
import script from "./ChangeOfDeputySecretary.vue?vue&type=script&lang=js&"
export * from "./ChangeOfDeputySecretary.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOfDeputySecretary.vue?vue&type=style&index=0&id=59b07f7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b07f7c",
  null
  
)

export default component.exports